module.exports = __webpack_public_path__ + "static/media/sound-wave.78f9cb09.svg";